module.exports = __webpack_public_path__ + "img/2021_IMG_20210131_213542.bed985b5.jpg";